"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateReferralRequestSchema = exports.Referral = exports.ReferralUserConfigSchema = exports.GenericReferralConfig = exports.ReferralConfig = exports.ReferralBonus = void 0;
const zod_1 = require("zod");
const types_1 = require("../types");
exports.ReferralBonus = zod_1.z.object({
    bonusCoins: zod_1.z.number(), // 500
    bonusInUSD: zod_1.z.number(), // 0.5
    bonusPiggyBanks: zod_1.z.number(), //500
});
exports.ReferralConfig = zod_1.z.object({
    refereeBonus: exports.ReferralBonus,
    referrerBonus: exports.ReferralBonus,
});
exports.GenericReferralConfig = exports.ReferralConfig.extend({
    totalPiggyBanksToEarn: zod_1.z.number(),
});
exports.ReferralUserConfigSchema = zod_1.z.object({
    createdAt: types_1.FTimestamp,
    isActive: zod_1.z.boolean(),
    referralConfig: exports.ReferralConfig.nullable(),
    referralId: zod_1.z.string(),
    updatedAt: types_1.FTimestamp,
    userId: zod_1.z.string(),
    nickname: zod_1.z.string().optional(),
});
exports.Referral = zod_1.z.object({
    activationTimestamp: types_1.FTimestamp,
    datePaidOut: types_1.FTimestamp.nullable(),
    earnedPiggyBanksByReferee: zod_1.z.number(),
    isPaidOut: zod_1.z.boolean(),
    referralId: zod_1.z.string(),
    referee: exports.ReferralBonus.extend({ name: zod_1.z.string(), userId: zod_1.z.string() }),
    referrer: exports.ReferralBonus.extend({ name: zod_1.z.string(), userId: zod_1.z.string() }),
});
exports.CreateReferralRequestSchema = zod_1.z.object({
    referrerUserId: zod_1.z.string(),
    refereeUserId: zod_1.z.string(),
});
